import {
  getDmUnread,
  getGrocery,
  getLastBoards,
  getLatestSystemDM,
  getUnreadNum,
} from "@/services";

export default function app(set, get) {
  return {
    envInfo: {
      env: process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod",
      isCanary: false,
    },
    categories: [],
    pinQueue: [],
    currentPin: null,
    currentPreview: {},
    isMobile: false,
    ads: null,
    /** 杂货铺来源字典数据*/
    /** 当前弹出折叠对象 */
    currentFold: null,
    /** 杂货铺来源字典数据 */
    domains: [],

    unreadNum: 0,
    dmUnread: null,
    latestSystemDM: null,
    /** 用户所有画板，不带封面信息 */
    lastBoards: [],
    lastBoardsReady: false,
    /** 更新当前用户画板 */
    async refreshLastBoards() {
      const { boards, err } = await getLastBoards();
      if (err) return;
      set({
        lastBoards: boards,
        lastBoardsReady: true,
      });
      return boards;
    },
    setLastBoards(boards) {
      set({
        lastBoards: boards,
      });
    },
    // 获取未读私信消息数量
    async refreshDmUnread() {
      const result = await getDmUnread();
      if (result.err) return;

      const prevUnread = get().dmUnread;
      // 有新的系统消息时，获取最新的系统消息
      if (
        +result?.unread_system_dm &&
        result?.unread_system_dm !== prevUnread?.unread_system_dm
      ) {
        const systemDM = await getLatestSystemDM();
        if (!systemDM.err) {
          set({
            dmUnread: result,
            latestSystemDM: systemDM,
          });
        }
      } else {
        set({
          dmUnread: result,
        });
      }
    },
    // 获取消息消息数量
    async refreshUnreadMsg() {
      const result = await getUnreadNum();
      if (result.err) return;
      set({
        unreadNum: result,
      });
    },

    pinIds: [],
    // sucaiIsRead: false,
    // 应用全局配置 配置地址： https://grocery.huaban.com/put/6
    config: null,
    async getAppConfig() {
      const data = await getGrocery("global-config");
      set({
        config: data || {},
      });
    },
  };
}
